export const PLATFORM_MODERATION_APPEAL_MESSAGE_MAX = 2000;

export type PlatformModerationAppealType = 'account_ban' | 'creator_disabled';
export type PlatformModerationAppealDecision = 'approved' | 'denied';

export function validatePlatformModerationAppealMessage(
  message: string | null | undefined,
): { ok: true; message: string } | { ok: false; message: string } {
  const trimmed = (message ?? '').trim();
  if (!trimmed) {
    return { ok: false, message: 'Appeal message is required' };
  }
  if (trimmed.length > PLATFORM_MODERATION_APPEAL_MESSAGE_MAX) {
    return {
      ok: false,
      message: `Appeal message must be ${PLATFORM_MODERATION_APPEAL_MESSAGE_MAX} characters or fewer`,
    };
  }
  return { ok: true, message: trimmed };
}

export function canSubmitPlatformModerationAppeal(params: {
  appealType: PlatformModerationAppealType;
  accountStatus?: string | null;
  creatorDisabled?: boolean;
  hasPendingAppeal?: boolean;
  hasExistingAppeal?: boolean;
}): { ok: true } | { ok: false; message: string } {
  if (params.hasPendingAppeal) {
    return { ok: false, message: 'You already have a pending appeal' };
  }
  if (params.hasExistingAppeal) {
    return { ok: false, message: 'You have already submitted an appeal for this action' };
  }

  if (params.appealType === 'account_ban') {
    if (params.accountStatus !== 'banned') {
      return { ok: false, message: 'Only restricted accounts can submit a ban appeal' };
    }
    return { ok: true };
  }

  if (!params.creatorDisabled) {
    return { ok: false, message: 'Only suspended creator accounts can submit this appeal' };
  }
  if (params.accountStatus === 'banned') {
    return { ok: false, message: 'Submit an account ban appeal instead' };
  }
  return { ok: true };
}
